import api from './api';

const analyticsService = {
  /**
   * Get overview analytics
   */
  getOverview: async () => {
    const response = await api.get('/analytics/overview');
    return response.data;
  },

  /**
   * Get progress over time
   * @param {number} days - Number of days to fetch (default 30)
   */
  getProgressOverTime: async (days = 30) => {
    const response = await api.get(`/analytics/progress-over-time?days=${days}`);
    return response.data;
  },

  /**
   * Get quiz performance analytics
   */
  getQuizPerformance: async () => {
    const response = await api.get('/analytics/quiz-performance');
    return response.data;
  },

  /**
   * Get time tracking analytics
   */
  getTimeAnalytics: async () => {
    const response = await api.get('/analytics/time-analytics');
    return response.data;
  },

  /**
   * Get badge achievement timeline
   */
  getBadgeTimeline: async () => {
    const response = await api.get('/analytics/badge-timeline');
    return response.data;
  },
};

export default analyticsService;
